<div class="first-row">
	<div class="title" *ngIf="type === 'page'">
		{{ 'PROMPTUARY.TITLE' | translate }}
	</div>
	<label
		class="noshow"
		*ngIf="!appointment.sessionInFuture"
		[ngClass]="{
			disabled: appointment.notEditable,
			'noshow-sidebar': type === 'sidebar'
		}"
		pTooltip="{{
			appointment.notEditable ? ('CONTACT.INFOS.NOT_EDITABLE' | translate) : ''
		}}"
		tooltipPosition="top"
	>
		<input
			[id]="formatNoShowId(appointment.id)"
			type="checkbox"
			(change)="changeCheckbox($event.target.checked)"
			[checked]="appointment.noShow"
			[disabled]="appointment.notEditable"
		/>
		{{ 'PROMPTUARY.NOSHOW.CHECKBOX_LABEL' | translate }}
	</label>
</div>

<div class="zk-flex zk-gap-2 zk-items-center" *ngIf="type === 'page'">
	<span class="freud-icon freud-icon-shield-check"></span>
	<div class="subtitle zk-my-2">
		{{ 'PROMPTUARY.SUBTITLE' | translate }}
	</div>
</div>

<span class="required-fields zk-mb-3" *ngIf="type === 'page'">
	{{ 'PROMPTUARY.REQUIRED_FIELDS' | translate }}
</span>

<div class="noshow-content" *ngIf="noshowStatus === true">
	<freud-select
		(onChange)="selectedReasonId = $event.value"
		[(ngModel)]="selectedReasonId"
		[disabled]="appointment.notEditable"
		[label]="'PROMPTUARY.NOSHOW.SELECT_LABEL' | translate"
		[options]="reasonsList"
		[placeholder]="'PROMPTUARY.NOSHOW.SELECT_PLACEHOLDER' | translate"
		optionLabel="name"
		optionValue="id"
	></freud-select>

	<freud-button
		[color]="primary"
		[size]="md"
		[disabled]="appointment.notEditable || !selectedReasonId"
		[loading]="savingReason"
		(click)="saveNoshowReason()"
	>
		{{ 'PROMPTUARY.NOSHOW.SAVE_CHANGES' | translate }}
	</freud-button>
</div>

<freud-dialog class="noshow-modal" [visible]="noShowConfirmed !== null" (visibleChange)="!$event && closeNoShowModal()"
	[modal]="true" [draggable]="false" [header]="'SCHEDULE.NOSHOW_CONFIRM_TITLE' | translate">
	<span class="noshow-modal__description">{{
		'SCHEDULE.NOSHOW_CONFIRM_DESC' | translate
		}}</span>
	<ng-container freudTemplatefooter>
		<freud-button (click)="saveNoshowReason(true)" [loading]="loadingConfirmNoShow">{{
			'SCHEDULE.NOSHOW_CONFIRM_BUTTON' | translate
			}}</freud-button>
		<freud-button color="ghost" (click)="closeNoShowModal()"> {{ 'SCHEDULE.NOSHOW_CANCEL_BUTTON' | translate
			}}</freud-button>
	</ng-container>
</freud-dialog>